var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('notification',{attrs:{"notification":_vm.notification}},[_c('template',{slot:"title"},[_vm._v("\n      欢迎加入小丑路人社区，\n      "),_c('small',[_vm._v(_vm._s(_vm.notification.notify_content))])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }